import { GET_DASHBOARD_V2_PERFORMANCE, GET_DASHBOARD_V2_STATIONS } from 'actions/dashboardV2';
import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { API } from '../api';

function* getDashboardV2Performance(action) {
  try {
    const response = yield call(API.getDashboardV2Performance, action.payload);
    yield put({ type: GET_DASHBOARD_V2_PERFORMANCE.SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: GET_DASHBOARD_V2_PERFORMANCE.FAIL, payload: { error: e } });
  }
}

function* getDashboardV2Stations(action) {
  try {
    const response = yield call(API.getDashboardV2Stations, action.payload);
    yield put({
      type: GET_DASHBOARD_V2_STATIONS.SUCCESS,
      payload: {
        key: `${action.payload.type}_${action.payload.category}`,
        data: response.data,
      },
    });
  } catch (e) {
    yield put({ type: GET_DASHBOARD_V2_STATIONS.FAIL, payload: { error: e } });
  }
}

function* dashboardV2() {
  yield takeLatest(GET_DASHBOARD_V2_PERFORMANCE.REQUEST, getDashboardV2Performance);
  yield takeEvery(GET_DASHBOARD_V2_STATIONS.REQUEST, getDashboardV2Stations);
}

export default dashboardV2;
